<template>
  <v-card outlined>
    <v-card-title>
      CONSULTA PAGOS SIGEP
      <v-spacer/>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="monto"
              append-icon="mdi-currency-usd"
              label="Monto Total"
              single-line
              hide-details
              type="number"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="periodo"
              append-icon="mdi-calendar"
              label="Periodo"
              single-line
              hide-details
              type="number"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
              v-model="nroFactura"
              append-icon="mdi-receipt"
              label="Número de Factura"
              single-line
              hide-details
              type="number"
          />
        </v-col>
        <v-col cols="12" md="1" class="text-right">
          <v-btn color="accent" class="ma-3" title="Actualizar cajeros" outlined @click="buscar()">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4"></v-col>
        <v-col cols="12" md="4">
          <v-simple-table>
            <thead>
              <th>Nro</th>
              <th>Cuenta</th>
              <th>Tarifa</th>
              <th>Monto</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in datos" :key="index">
                <td>{{ index +1 }}</td>
                <td>{{ item.pla_matr }}{{ item.pla_dive }}</td>
                <td>{{ item.pla_tari }}</td>
                <td>{{ item.pla_totmes }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="4"></v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {Alert} from "@/addons/Alert";
import { http } from "@/config/HttpClient";

@Component({
  name: "ConsultaIndex",
})
export default class ConsultaIndex extends Vue {
  public monto = 0;
  public periodo = '';
  public nroFactura = '';
  public loading = false;
  public datos = [];

  private async buscar() {
    let data = {
      monto: this.monto,
      tarifa: this.periodo,
      pla_nume: this.nroFactura
    }
    this.loading = true;
        await http.get("consulta-pago-sigep", {params: data}).subscribe({
            next: (response) => {
              this.datos = response.data
                this.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.loading = false;
            }
        })
  }


}
</script>

<style scoped>

</style>